import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/payment-gates/{paymentGateId}/assignees';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updatePaymentGateAssignees = async ({ paymentGateId, userIds }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { paymentGateId });
  const response = await noodleApiClient.put(path, { userIds });
  return response.data;
};

export default updatePaymentGateAssignees;
